import React from 'react';
 
 
 const FormIcon = () => {
 
 return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 4.4C4.44772 4.4 4 4.89249 4 5.5C4 6.10751 4.44772 6.6 5 6.6H13C13.5523 6.6 14 6.10751 14 5.5C14 4.89249 13.5523 4.4 13 4.4H5Z" fill="#404268"/>
    <path d="M4 9.9C4 9.29249 4.44772 8.8 5 8.8H13C13.5523 8.8 14 9.29249 14 9.9C14 10.5075 13.5523 11 13 11H5C4.44772 11 4 10.5075 4 9.9Z" fill="#404268"/>
    <path d="M5 13.2C4.44772 13.2 4 13.6925 4 14.3C4 14.9075 4.44772 15.4 5 15.4H9C9.55228 15.4 10 14.9075 10 14.3C10 13.6925 9.55228 13.2 9 13.2H5Z" fill="#404268"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.984974 0 2.2V19.8C0 21.015 0.89543 22 2 22H16C17.1046 22 18 21.015 18 19.8V2.2C18 0.984974 17.1046 0 16 0H2ZM16 2.2H2L2 19.8H10.5622L16 13.3199V2.2ZM16 19.8H13.284L16 16.5634V19.8Z" fill="#404268"/>
    </svg>
    )

 }

export default FormIcon
